import {SET_GIFT_CARD_DATA, UPDATE_GIFT_CARD_DATA} from './constants';

export const initialState = {};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_GIFT_CARD_DATA:
      return action.payload;
    case UPDATE_GIFT_CARD_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
